require("es6-promise").polyfill();
require("isomorphic-fetch");

const baseUrl = process.env.API_URL + "/cms/modules/Uneto/ledenzoek2020/";
const token = "0622D836-AA7B-4B50-AB1B-8D29BED1A103";

export function getData(path) {
  return fetch(baseUrl + path + "?token=" + token)
    .then(handleResponse)
    .catch(handleError);
}

export function getPosition(zipcode) {
  return fetch(baseUrl + "GetLatLong.aspx?postalCode=" + zipcode + "&token=" + token)
    .then(handleResponse)
    .catch(handleError);
}

export function postData(data, path) {
  var formData = new FormData();
  for (const [key, value] of Object.entries(data)) {
    formData.append(key, value);
  }

  return fetch(baseUrl + path, {
    method: "POST",
    body:  formData
  })
    .then(handleResponse)
    .catch(handleError);
}

function handleResponse(response) {
  if (response.ok) return response.json();
  throw new Error("Network response was not ok.");
}

function handleError(error) {
  console.error("API call failed. " + error);
  throw error;
}
